import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  static values = { autoTrigger: Boolean };

  connect() {
    this.element.addEventListener("click", this.handleClick.bind(this));

    // Auto-trigger modal if autoTrigger value is true
    if (this.autoTriggerValue) {
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        this.openAuthModal();
      }, 100);
    }
  }

  handleClick(event) {
    event.preventDefault();
    this.openAuthModal();
  }

  openAuthModal() {
    // Get URL parameters to pass redirect_to if present
    const urlParams = new URLSearchParams(window.location.search);
    const redirectTo = urlParams.get("redirect_to");
    const auth = urlParams.get("auth");

    // Build auth URL with parameters
    let authUrl = "/auth";
    const params = new URLSearchParams();

    if (redirectTo) {
      params.append("redirect_to", redirectTo);
    }

    // If this was triggered by auto-redirect, default to signin tab
    if (auth === "true") {
      params.append("tab", "signin");
    }

    if (params.toString()) {
      authUrl += "?" + params.toString();
    }

    // Create a temporary link element that targets the modal turbo frame
    const tempLink = document.createElement("a");
    tempLink.href = authUrl;
    tempLink.setAttribute("data-turbo-frame", "modal_content");
    tempLink.style.display = "none";

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  }
}
